/**
 * @file
 * @fileOverview This file contains the TwitchIntegration class for integrating with the Twitch API
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

class TwitchIntegration {
    constructor(clientId, redirectUri) {
        this.clientId = clientId;
        this.redirectUri = redirectUri;
        this.token = null;
        this.chatClient = null;
    }

    // Start OAuth flow
    authenticate(scopes = ['chat:read', 'chat:edit', 'user:read:email']) {
        const authUrl = `https://id.twitch.tv/oauth2/authorize?client_id=${this.clientId}&redirect_uri=${this.redirectUri}&response_type=token&scope=${scopes.join('+')}`;
        window.location.href = authUrl;
    }

    // Extract the OAuth token from the URL after redirect
    extractTokenFromUrl() {
        const params = new URLSearchParams(window.location.hash.substring(1));
        this.token = params.get('access_token');
        console.log('OAuth Token:', this.token);
        return this.token;
    }

    // Fetch user data from Twitch API
    async fetchUserData() {
        if (!this.token) throw new Error('Token not found. Authenticate first.');

        const response = await fetch('https://api.twitch.tv/helix/users', {
            headers: {
                'Authorization': `Bearer ${this.token}`,
                'Client-Id': this.clientId,
            },
        });

        const data = await response.json();
        console.log('User Data:', data);
        return data.data[0]; // Return the first user (usually the authenticated user)
    }

    // Connect to Twitch chat
    connectToChat(username, channel) {
        if (!this.token) throw new Error('Token not found. Authenticate first.');

        this.chatClient = new WebSocket('wss://irc-ws.chat.twitch.tv:443');

        this.chatClient.onopen = () => {
            console.log('Connected to Twitch Chat');
            this.chatClient.send(`PASS oauth:${this.token}`);
            this.chatClient.send(`NICK ${username}`);
            this.chatClient.send(`JOIN #${channel}`);
        };

        this.chatClient.onmessage = (event) => {
            console.log('Chat Message:', event.data);
        };

        this.chatClient.onclose = () => {
            console.log('Disconnected from Twitch Chat');
        };
    }

    // Send message to chat
    sendMessage(channel, message) {
        if (!this.chatClient || this.chatClient.readyState !== WebSocket.OPEN) {
            throw new Error('Chat client not connected.');
        }

        this.chatClient.send(`PRIVMSG #${channel} :${message}`);
        console.log(`Message sent to #${channel}: ${message}`);
    }
}

export default TwitchIntegration;
